import React from 'react'
import './styles.css'

/**
 * Renders a Anchor offsetting de fixed header.
 *
 * @component
 * @param {string} id - Anchor id.
 * return (
 *   <Anchor id={id}/>
 * );
 */

const Anchor = ({ id }) => <hr id={id} />

export default Anchor
